import React from "react";
import {
  FaLaptopCode,
  FaCogs,
  FaChartLine,
  FaShieldAlt,
  FaMoneyBillWave,
  FaUserFriends,
} from "react-icons/fa";

function P2PFeature({ icon: Icon, title, description }) {
  return (
    <div className="services-style-four-item">
      <div className="icon" style={{ fontSize: "40px", color: "#007bff" }}>
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function CustomLPlat() {
  const features = [
    {
      title: "Custom P2P Lending Platform",
      description:
        "Develop tailored platforms that allow borrowers and lenders to connect directly, minimizing intermediaries and enhancing returns.",
      icon: FaLaptopCode,
    },
    {
      title: "Smart Contract Integration",
      description:
        "Automate lending contracts and ensure trustless transactions with secure, transparent smart contracts to manage loan terms and repayments.",
      icon: FaCogs,
    },
    {
      title: "Risk Management & Scoring Algorithms",
      description:
        "Implement custom algorithms for borrower risk assessment, enabling safe lending through data-driven scoring models.",
      icon: FaChartLine,
    },
    {
      title: "Compliance & Security",
      description:
        "Our platforms are built to comply with KYC, AML, and financial regulations, incorporating multi-factor authentication and secure data storage.",
      icon: FaShieldAlt,
    },
    {
      title: "Multi-Currency & Payment Gateway Support",
      description:
        "Enable multiple currencies, both fiat and crypto, along with payment gateways to facilitate seamless fund transfers between users.",
      icon: FaMoneyBillWave,
    },
    {
      title: "User-Friendly Interface",
      description:
        "Design an intuitive UI/UX, ensuring ease of use for both borrowers and lenders with features like loan tracking, payment alerts, and real-time analytics.",
      icon: FaUserFriends,
    },
  ];

  return (
    <div className="team-single-area default-padding">
      <div className="container">
        <div className="team-single-items">
          <div className="row">
            <div className="col-lg-5 left-info">
              <div className="thumb fade-up-anim">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                  alt="Thumb"
                />
              </div>
            </div>
            <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
              <div className="container">
                <div className="col-lg-12">
                  <div className="site-heading">
                    <h4 className="sub-title">Our Services</h4>
                    <h2 className="title split-text-right split-text-in-right split-lines">
                      P2P Lending Development Services
                    </h2>
                  </div>
                </div>
              </div>
              <div className="container services-style-four-items fade-up-anim">
                {features.map((feature, idx) => (
                  <P2PFeature key={idx} {...feature} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomLPlat;
